module.exports = __webpack_public_path__ + "img/016-nepal.1484d4b8.svg";